import type { SVGProps } from 'react';

export const SvgGuideIllustKabukatsu = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={363} height={288} viewBox="0 0 363 288" fill="none" {...props}>
    <g clipPath="url(#img-guide01_svg__a)">
      <path
        fill="#FBDED7"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="M181.001 264.539 8 164.656l172.999-99.88L354 164.658z"
      />
      <path
        fill="url(#img-guide01_svg__b)"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="M8 177.903v-13.247l173.001 99.883v13.246z"
      />
      <path
        fill="url(#img-guide01_svg__c)"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="M354 164.658v13.247l-172.999 99.88v-13.246z"
      />
      <path
        fill="#9E700A"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m49.946 145.31 3.51 2.029V71.237l-3.51-2.025zM109.693 110.818l3.509 2.024V51.204l-3.509-2.024z"
      />
      <path
        fill="#FBDED7"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="M113.202 32.69 49.947 69.214l3.508 2.024 63.256-36.522z"
      />
      <path
        fill="#C79B69"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m56.964 145.31-3.509 2.029V71.236l63.256-36.522v76.103l-3.509 2.024V94.847l-56.238 32.469z"
      />
      <path
        fill="#E7E7E7"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="M110.792 85.766V57.75L95.56 66.546V94.56zm-17.87 10.318V68.069L77.69 76.863v28.02l15.232-8.794zM75.057 78.382l-15.233 8.794v28.015l15.233-8.794z"
      />
      <path
        fill="#B5D56E"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="M105.195 28.068 41.939 64.59 61.458 75.86l63.255-36.523z"
      />
      <path
        fill="#FBDED7"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m41.94 67.678 19.518 11.269v-3.088l-19.519-11.27z"
      />
      <path
        fill="#88BE43"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="M124.713 42.43 61.457 78.947v-3.088l63.256-36.522z"
      />
      <path
        fill="#88BE43"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m41.94 67.678 19.518 11.269v-3.088l-19.519-11.27z"
      />
      <path
        fill="#EDA94F"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m254.363 91.61.136 44.885-50.581 29.198-.125-44.873z"
      />
      <path
        fill="#EDD14F"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m203.918 165.693-72.847-42.336-.136-44.873 72.859 42.336z"
      />
      <path
        fill="#FF0019"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m203.794 120.819-72.859-42.335 50.581-29.21 72.847 42.336z"
      />
      <path
        fill="#ABDCE9"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m203.805 124.897-72.87-42.336v-4.077l72.859 42.336zM203.918 165.693l-72.847-42.336-.136-4.077 72.972 42.335z"
      />
      <path
        fill="#FF0019"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m254.363 91.61.011 4.09-50.569 29.197-.012-4.077z"
      />
      <path
        fill="#70C0DB"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m254.488 132.417.011 4.078-50.581 29.197-.011-4.077z"
      />
      <path
        fill="#FBDED7"
        d="m217.673 80.419-6.229 5.187c3.443 1.28 3.952 4.202 1.144 6.535-2.809 2.333-7.861 3.194-11.304 1.914l-6.229 5.187 41.079 15.267 22.618-18.834-41.079-15.267z"
      />
      <path
        fill="#fff"
        d="m258.751 95.675-22.617 18.835 16.298 6.048 6.229-5.187c-3.443-1.28-3.953-4.202-1.144-6.535s7.86-3.194 11.303-1.915l6.229-5.187-16.298-6.048z"
      />
      <path
        fill="#FF0019"
        d="M257.2 98.403a1.24 1.24 0 0 1-1.181-.442 1.25 1.25 0 0 1 .165-1.777l.972-.806a1.261 1.261 0 1 1 1.611 1.943l-.971.805a1.3 1.3 0 0 1-.596.276M241.392 111.56a1.24 1.24 0 0 1-1.181-.441 1.25 1.25 0 0 1 .166-1.777l1.755-1.458a1.26 1.26 0 0 1 1.777.166 1.25 1.25 0 0 1-.165 1.777l-1.756 1.457a1.3 1.3 0 0 1-.596.276m5.266-4.382a1.24 1.24 0 0 1-1.181-.442 1.25 1.25 0 0 1 .165-1.777l1.755-1.457a1.263 1.263 0 0 1 1.778.166 1.25 1.25 0 0 1-.166 1.777l-1.755 1.457a1.3 1.3 0 0 1-.596.276m5.276-4.393a1.24 1.24 0 0 1-1.181-.442 1.25 1.25 0 0 1 .166-1.777l1.755-1.457a1.26 1.26 0 0 1 1.777.165c.453.541.375 1.336-.166 1.778l-1.755 1.457a1.3 1.3 0 0 1-.596.276M236.911 115.291a1.24 1.24 0 0 1-1.181-.441 1.26 1.26 0 0 1 .165-1.777l.972-.806a1.26 1.26 0 1 1 1.611 1.942l-.971.806a1.3 1.3 0 0 1-.596.276"
      />
      <path
        stroke="#FF0019"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m275.049 101.734-6.229 5.187c-3.443-1.28-8.494-.419-11.303 1.914s-2.288 5.266 1.144 6.535l-6.229 5.187-57.377-21.315 6.229-5.187c3.443 1.28 8.495.419 11.304-1.915 2.808-2.333 2.287-5.266-1.144-6.534l6.229-5.188z"
      />
      <path
        fill="#FBDED7"
        d="m192.054 82.016-7.566 2.922c2.843 2.31 2.39 5.244-1.008 6.557-3.409 1.314-8.472.499-11.315-1.812l-7.565 2.922 34.023 27.624 27.465-10.59-34.023-27.623z"
      />
      <path
        fill="#fff"
        d="m226.076 109.639-27.465 10.59 13.489 10.952 7.566-2.922c-2.843-2.311-2.39-5.244 1.008-6.558 3.409-1.314 8.472-.498 11.314 1.812l7.566-2.922-13.489-10.952z"
      />
      <path
        fill="#FF0019"
        d="M223.877 111.683a1.25 1.25 0 0 1-.988-.799 1.275 1.275 0 0 1 .722-1.642l1.187-.455a1.275 1.275 0 0 1 1.642.721c.255.644-.078 1.387-.721 1.643l-1.187.455c-.222.088-.444.1-.655.066zM204.58 119.118a1.25 1.25 0 0 1-.987-.799 1.275 1.275 0 0 1 .721-1.642l2.142-.821a1.264 1.264 0 0 1 1.642.721 1.275 1.275 0 0 1-.721 1.642l-2.142.821c-.222.089-.444.1-.655.067zm6.436-2.475a1.25 1.25 0 0 1-.987-.799 1.273 1.273 0 0 1 .721-1.642l2.142-.821a1.266 1.266 0 0 1 1.642.721 1.276 1.276 0 0 1-.721 1.643l-2.142.821c-.222.088-.444.1-.655.066zm6.425-2.485a1.25 1.25 0 0 1-.988-.799 1.274 1.274 0 0 1 .722-1.642l2.141-.822a1.265 1.265 0 0 1 1.642.722 1.273 1.273 0 0 1-.721 1.642l-2.141.821c-.222.089-.444.1-.655.067zM199.11 121.226a1.25 1.25 0 0 1-.987-.799 1.273 1.273 0 0 1 .721-1.642l1.187-.455a1.264 1.264 0 0 1 1.642.721 1.273 1.273 0 0 1-.721 1.642l-1.187.455c-.222.089-.444.1-.655.067z"
      />
      <path
        stroke="#FF0019"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="M239.565 120.603 232 123.525c-2.843-2.311-7.917-3.126-11.315-1.812-3.409 1.313-3.851 4.247-1.008 6.557l-7.565 2.922L164.6 92.605l7.565-2.922c2.843 2.31 7.917 3.126 11.315 1.812s3.862-4.247 1.008-6.557l7.566-2.922z"
      />
      <path
        fill="#FBDED7"
        d="m183.056 61.394-6.954 4.167c3.205 1.79 3.262 4.757.125 6.637-3.126 1.88-8.257 1.948-11.462.159l-6.954 4.168 38.247 21.394 25.245-15.142-38.247-21.395z"
      />
      <path
        fill="#fff"
        d="M221.303 82.788 196.058 97.93l15.165 8.483 6.954-4.167c-3.205-1.79-3.261-4.757-.124-6.637 3.126-1.88 8.256-1.948 11.462-.159l6.954-4.168-15.166-8.483z"
      />
      <path
        fill="#FF0019"
        d="M219.967 84.895c-.442 0-.884-.215-1.133-.635a1.293 1.293 0 0 1 .442-1.778l1.11-.668a1.294 1.294 0 0 1 1.778.442c.374.612.17 1.404-.442 1.778l-1.11.668a1.24 1.24 0 0 1-.645.181zM201.879 95.745c-.441 0-.883-.215-1.132-.634a1.293 1.293 0 0 1 .442-1.778l2.016-1.2a1.294 1.294 0 1 1 1.336 2.22l-2.016 1.2c-.204.124-.43.18-.646.18zm6.026-3.624c-.442 0-.884-.215-1.133-.634a1.294 1.294 0 0 1 .442-1.779l2.016-1.2a1.304 1.304 0 0 1 1.778.442c.374.611.17 1.404-.442 1.778l-2.016 1.2c-.203.125-.43.181-.645.181zm6.036-3.613c-.441 0-.883-.215-1.132-.634a1.293 1.293 0 0 1 .442-1.779l2.016-1.2a1.294 1.294 0 0 1 1.778.442c.373.611.17 1.404-.442 1.778l-2.016 1.2c-.204.125-.43.181-.646.181zM196.737 98.814c-.441 0-.883-.215-1.132-.634a1.303 1.303 0 0 1 .442-1.778l1.11-.668a1.294 1.294 0 0 1 1.778.441c.362.612.17 1.405-.442 1.779l-1.11.668a1.24 1.24 0 0 1-.646.181z"
      />
      <path
        stroke="#FF0019"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m236.468 91.27-6.954 4.169c-3.205-1.79-8.335-1.722-11.461.158s-3.07 4.848.124 6.637l-6.954 4.168-53.424-29.877 6.954-4.168c3.206 1.79 8.336 1.721 11.462-.159s3.069-4.847-.124-6.637l6.954-4.168z"
      />
      <path
        fill="#FBDED7"
        d="m161.346 66.354-6.954 4.168c3.205 1.79 3.262 4.757.125 6.637-3.126 1.88-8.257 1.948-11.462.159l-6.954 4.168 38.247 21.394 25.245-15.142-38.247-21.395z"
      />
      <path
        fill="#fff"
        d="m199.593 87.749-25.245 15.142 15.165 8.483 6.955-4.168c-3.206-1.789-3.262-4.756-.125-6.637 3.126-1.88 8.256-1.948 11.462-.158l6.954-4.168-15.166-8.483z"
      />
      <path
        fill="#FF0019"
        d="M197.934 90.033a1.29 1.29 0 0 1-1.117-.625 1.276 1.276 0 0 1 .436-1.754l1.094-.66a1.276 1.276 0 0 1 1.754.436 1.276 1.276 0 0 1-.435 1.754l-1.095.66a1.2 1.2 0 0 1-.637.178zM180.082 100.736c-.436 0-.871-.212-1.117-.626a1.275 1.275 0 0 1 .436-1.754l1.988-1.184a1.286 1.286 0 0 1 1.754.436 1.275 1.275 0 0 1-.436 1.754l-1.988 1.184a1.2 1.2 0 0 1-.637.179zm5.955-3.564c-.436 0-.872-.212-1.118-.626a1.277 1.277 0 0 1 .436-1.754l1.989-1.184a1.286 1.286 0 0 1 1.754.436 1.277 1.277 0 0 1-.436 1.754l-1.989 1.184a1.2 1.2 0 0 1-.636.179zm5.943-3.564c-.436 0-.872-.212-1.117-.625a1.276 1.276 0 0 1 .435-1.754l1.989-1.184a1.277 1.277 0 0 1 1.754.435 1.276 1.276 0 0 1-.436 1.754l-1.988 1.184a1.2 1.2 0 0 1-.637.18zM175.021 103.774c-.436 0-.871-.212-1.117-.626a1.285 1.285 0 0 1 .436-1.754l1.094-.659a1.277 1.277 0 1 1 1.319 2.19l-1.095.659a1.2 1.2 0 0 1-.637.179z"
      />
      <path
        stroke="#FF0019"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m214.77 96.232-6.954 4.168c-3.205-1.79-8.336-1.722-11.462.158s-3.069 4.848.125 6.637l-6.954 4.168-53.424-29.877 6.954-4.168c3.205 1.79 8.336 1.721 11.462-.159s3.069-4.847-.125-6.637l6.954-4.168z"
      />
      <path
        fill="#FBDED7"
        d="m127.892 128.441-7.033 4.043c3.171 1.846 3.171 4.825 0 6.637-3.16 1.812-8.291 1.79-11.462-.057l-7.033 4.044 37.85 22.096 25.518-14.667-37.851-22.096z"
      />
      <path
        fill="#fff"
        d="m165.742 150.537-25.517 14.667 15.007 8.766 7.033-4.043c-3.171-1.846-3.171-4.825 0-6.637 3.16-1.824 8.291-1.79 11.462.056l7.033-4.043-15.006-8.766z"
      />
      <path
        fill="#FF0019"
        d="M164.372 152.622c-.441 0-.883-.238-1.121-.646a1.284 1.284 0 0 1 .476-1.767l1.121-.645a1.284 1.284 0 0 1 1.767.475 1.293 1.293 0 0 1-.476 1.767l-1.121.646c-.204.113-.43.17-.646.17M146.081 163.132a1.31 1.31 0 0 1-1.121-.646 1.283 1.283 0 0 1 .476-1.766l2.027-1.167a1.293 1.293 0 0 1 1.767.476 1.283 1.283 0 0 1-.476 1.766l-2.027 1.167c-.204.113-.431.17-.646.17m6.105-3.5a1.31 1.31 0 0 1-1.121-.645 1.283 1.283 0 0 1 .475-1.767l2.028-1.167a1.293 1.293 0 0 1 1.766.476 1.283 1.283 0 0 1-.475 1.767l-2.028 1.166a1.33 1.33 0 0 1-.645.17m6.093-3.511c-.442 0-.883-.238-1.121-.645a1.283 1.283 0 0 1 .476-1.767l2.027-1.167a1.284 1.284 0 0 1 1.767.476 1.284 1.284 0 0 1-.476 1.767l-2.027 1.166c-.204.114-.431.17-.646.17M140.894 166.122a1.31 1.31 0 0 1-1.121-.645c-.351-.623-.148-1.416.475-1.767l1.122-.646a1.283 1.283 0 0 1 1.766.476 1.29 1.29 0 0 1-.475 1.767l-1.122.645a1.34 1.34 0 0 1-.645.17"
      />
      <path
        stroke="#FF0019"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m180.761 159.303-7.034 4.044c-3.171-1.847-8.301-1.869-11.461-.057s-3.16 4.791 0 6.637l-7.034 4.043-52.857-30.851 7.033-4.044c3.171 1.847 8.302 1.869 11.462.057s3.16-4.791 0-6.637l7.033-4.043 52.858 30.863z"
      />
      <path
        fill="#FBDED7"
        d="m127.892 121.612-7.033 4.043c3.171 1.846 3.171 4.825 0 6.637-3.16 1.812-8.291 1.789-11.462-.057l-7.033 4.043 37.85 22.097 25.518-14.667-37.851-22.096z"
      />
      <path
        fill="#fff"
        d="m165.742 143.708-25.517 14.667 15.007 8.766 7.033-4.043c-3.171-1.846-3.171-4.825 0-6.637 3.16-1.823 8.291-1.789 11.462.057l7.033-4.044-15.006-8.766z"
      />
      <path
        fill="#FF0019"
        d="M164.372 145.781c-.441 0-.883-.238-1.121-.646a1.283 1.283 0 0 1 .476-1.766l1.121-.646a1.284 1.284 0 0 1 1.767.476 1.294 1.294 0 0 1-.476 1.767l-1.121.645c-.204.113-.43.17-.646.17M146.081 156.303a1.31 1.31 0 0 1-1.121-.646 1.284 1.284 0 0 1 .476-1.767l2.027-1.166a1.293 1.293 0 0 1 1.767.476 1.283 1.283 0 0 1-.476 1.766l-2.027 1.167c-.204.113-.431.17-.646.17m6.105-3.511a1.31 1.31 0 0 1-1.121-.646 1.283 1.283 0 0 1 .475-1.767l2.028-1.166a1.293 1.293 0 0 1 1.766.476 1.28 1.28 0 0 1-.475 1.766l-2.028 1.167a1.34 1.34 0 0 1-.645.17m6.093-3.5c-.442 0-.883-.238-1.121-.645a1.283 1.283 0 0 1 .476-1.767l2.027-1.167a1.284 1.284 0 0 1 1.767.476 1.284 1.284 0 0 1-.476 1.767l-2.027 1.166c-.204.114-.431.17-.646.17M140.894 159.281a1.31 1.31 0 0 1-1.121-.645c-.351-.623-.148-1.416.475-1.767l1.122-.646a1.283 1.283 0 0 1 1.766.476 1.29 1.29 0 0 1-.475 1.767l-1.122.645a1.33 1.33 0 0 1-.645.17"
      />
      <path
        stroke="#FF0019"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m180.761 152.463-7.034 4.043c-3.171-1.846-8.301-1.868-11.461-.056s-3.16 4.79 0 6.637l-7.034 4.043-52.857-30.852 7.033-4.043c3.171 1.846 8.302 1.869 11.462.057s3.16-4.791 0-6.637l7.033-4.044 52.858 30.863z"
      />
      <path
        fill="#FBDED7"
        d="m127.892 114.771-7.033 4.043c3.171 1.847 3.171 4.825 0 6.637-3.16 1.812-8.291 1.79-11.462-.056l-7.033 4.043 37.85 22.097 25.518-14.667-37.851-22.097z"
      />
      <path
        fill="#fff"
        d="m165.742 136.867-25.517 14.667 15.007 8.767 7.033-4.044c-3.171-1.846-3.171-4.825 0-6.637 3.16-1.823 8.291-1.789 11.462.057l7.033-4.043-15.006-8.767z"
      />
      <path
        fill="#FF0019"
        d="M164.372 138.952c-.441 0-.883-.238-1.121-.646a1.283 1.283 0 0 1 .476-1.766l1.121-.646a1.284 1.284 0 0 1 1.767.476 1.293 1.293 0 0 1-.476 1.767l-1.121.645c-.204.113-.43.17-.646.17M146.081 149.462c-.442 0-.883-.238-1.121-.645a1.284 1.284 0 0 1 .476-1.767l2.027-1.167a1.293 1.293 0 0 1 1.767.476 1.284 1.284 0 0 1-.476 1.767l-2.027 1.166c-.204.114-.431.17-.646.17m6.105-3.511a1.31 1.31 0 0 1-1.121-.645 1.283 1.283 0 0 1 .475-1.767l2.028-1.167a1.293 1.293 0 0 1 1.766.476 1.283 1.283 0 0 1-.475 1.767l-2.028 1.166a1.33 1.33 0 0 1-.645.17m6.093-3.499a1.31 1.31 0 0 1-1.121-.646 1.283 1.283 0 0 1 .476-1.767l2.027-1.166a1.283 1.283 0 0 1 1.767.475 1.284 1.284 0 0 1-.476 1.767l-2.027 1.167c-.204.113-.431.17-.646.17M140.894 152.441a1.31 1.31 0 0 1-1.121-.646c-.351-.623-.148-1.415.475-1.766l1.122-.646a1.283 1.283 0 0 1 1.766.476 1.293 1.293 0 0 1-.475 1.767l-1.122.645a1.34 1.34 0 0 1-.645.17"
      />
      <path
        stroke="#FF0019"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m180.76 145.634-7.033 4.043c-3.171-1.846-8.302-1.868-11.462-.056s-3.16 4.791 0 6.637l-7.033 4.043-52.858-30.863 7.034-4.043c3.171 1.846 8.301 1.869 11.461.056s3.16-4.79 0-6.636l7.034-4.044z"
      />
      <path
        fill="#FBDED7"
        d="m127.892 107.941-7.033 4.043c3.171 1.846 3.171 4.825 0 6.637-3.16 1.812-8.291 1.79-11.462-.056l-7.033 4.043 37.85 22.096 25.518-14.666-37.851-22.097z"
      />
      <path
        fill="#fff"
        d="m165.742 130.026-25.517 14.667 15.007 8.767 7.033-4.044c-3.171-1.846-3.171-4.825 0-6.637 3.16-1.823 8.291-1.789 11.462.057l7.033-4.043-15.006-8.767z"
      />
      <path
        fill="#FF0019"
        d="M164.372 132.111c-.441 0-.883-.238-1.121-.646a1.284 1.284 0 0 1 .476-1.767l1.121-.645a1.283 1.283 0 0 1 1.767.475 1.293 1.293 0 0 1-.476 1.767l-1.121.646c-.204.113-.43.17-.646.17M146.081 142.621a1.31 1.31 0 0 1-1.121-.646 1.284 1.284 0 0 1 .476-1.767l2.027-1.166c.623-.351 1.416-.148 1.767.475a1.284 1.284 0 0 1-.476 1.767l-2.027 1.167c-.204.113-.431.17-.646.17m6.105-3.5a1.31 1.31 0 0 1-1.121-.646 1.28 1.28 0 0 1 .475-1.766l2.028-1.167a1.293 1.293 0 0 1 1.766.476 1.283 1.283 0 0 1-.475 1.767l-2.028 1.166a1.34 1.34 0 0 1-.645.17m6.093-3.511a1.31 1.31 0 0 1-1.121-.646 1.28 1.28 0 0 1 .476-1.766l2.027-1.167a1.284 1.284 0 0 1 1.767.476 1.284 1.284 0 0 1-.476 1.767l-2.027 1.166c-.204.113-.431.17-.646.17M140.894 145.611a1.31 1.31 0 0 1-1.121-.646 1.293 1.293 0 0 1 .475-1.767l1.122-.645a1.28 1.28 0 0 1 1.766.476 1.29 1.29 0 0 1-.475 1.766l-1.122.646a1.34 1.34 0 0 1-.645.17"
      />
      <path
        stroke="#FF0019"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m180.761 138.793-7.034 4.043c-3.171-1.846-8.301-1.869-11.461-.057s-3.16 4.791 0 6.637l-7.034 4.044-52.857-30.852 7.033-4.043c3.171 1.846 8.302 1.869 11.462.056s3.16-4.79 0-6.637l7.033-4.043 52.858 30.863z"
      />
      <path
        fill="#FBDED7"
        d="m127.892 101.1-7.033 4.044c3.171 1.846 3.171 4.825 0 6.637-3.16 1.812-8.291 1.789-11.462-.057l-7.033 4.043 37.85 22.097 25.518-14.667-37.851-22.097z"
      />
      <path
        fill="#fff"
        d="m165.742 123.196-25.517 14.667 15.007 8.767 7.033-4.044c-3.171-1.846-3.171-4.825 0-6.637 3.16-1.823 8.291-1.789 11.462.057l7.033-4.043-15.006-8.767z"
      />
      <path
        fill="#FF0019"
        d="M164.372 125.269c-.441 0-.883-.238-1.121-.646a1.283 1.283 0 0 1 .476-1.766l1.121-.646a1.284 1.284 0 0 1 1.767.476 1.29 1.29 0 0 1-.476 1.766l-1.121.646c-.204.113-.43.17-.646.17M146.081 135.791a1.31 1.31 0 0 1-1.121-.646 1.284 1.284 0 0 1 .476-1.767l2.027-1.166a1.293 1.293 0 0 1 1.767.476 1.283 1.283 0 0 1-.476 1.766l-2.027 1.167c-.204.113-.431.17-.646.17m6.105-3.511a1.31 1.31 0 0 1-1.121-.646 1.283 1.283 0 0 1 .475-1.767l2.028-1.166a1.293 1.293 0 0 1 1.766.476 1.28 1.28 0 0 1-.475 1.766l-2.028 1.167a1.34 1.34 0 0 1-.645.17m6.093-3.5c-.442 0-.883-.238-1.121-.645a1.283 1.283 0 0 1 .476-1.767l2.027-1.167a1.284 1.284 0 0 1 1.767.476 1.284 1.284 0 0 1-.476 1.767l-2.027 1.166c-.204.114-.431.17-.646.17M140.894 138.769a1.31 1.31 0 0 1-1.121-.645c-.351-.623-.148-1.416.475-1.767l1.122-.646a1.283 1.283 0 0 1 1.766.476 1.29 1.29 0 0 1-.475 1.767l-1.122.645a1.33 1.33 0 0 1-.645.17"
      />
      <path
        stroke="#FF0019"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m180.761 131.963-7.034 4.043c-3.171-1.846-8.302-1.868-11.461-.056s-3.16 4.791 0 6.637l-7.034 4.043-52.857-30.863 7.033-4.043c3.171 1.846 8.302 1.869 11.462.056s3.16-4.79 0-6.636l7.033-4.044z"
      />
      <path
        fill="#FBDED7"
        d="m127.892 94.26-7.033 4.043c3.171 1.846 3.171 4.825 0 6.637-3.16 1.812-8.291 1.789-11.462-.057l-7.033 4.043 37.85 22.097 25.518-14.667-37.851-22.097z"
      />
      <path
        fill="#fff"
        d="m165.742 116.356-25.517 14.667 15.007 8.766 7.033-4.044c-3.171-1.846-3.171-4.824 0-6.637 3.16-1.823 8.291-1.789 11.462.057l7.033-4.043-15.006-8.766z"
      />
      <path
        fill="#FF0019"
        d="M163.552 118.887c-.427 0-.854-.229-1.084-.624a1.24 1.24 0 0 1 .46-1.708l1.084-.624a1.24 1.24 0 0 1 1.709.46 1.25 1.25 0 0 1-.46 1.708l-1.084.624c-.198.11-.417.164-.625.164M145.866 129.05c-.427 0-.854-.23-1.084-.625a1.24 1.24 0 0 1 .46-1.708l1.96-1.128a1.25 1.25 0 0 1 1.709.46c.35.602.142 1.369-.46 1.708l-1.96 1.128c-.197.11-.416.165-.625.165m5.903-3.384c-.427 0-.854-.23-1.084-.625a1.24 1.24 0 0 1 .46-1.708l1.96-1.128a1.25 1.25 0 0 1 1.708.46 1.24 1.24 0 0 1-.46 1.708l-1.96 1.128c-.197.11-.416.165-.624.165m5.892-3.395a1.27 1.27 0 0 1-1.085-.624 1.24 1.24 0 0 1 .46-1.709l1.961-1.128a1.24 1.24 0 0 1 1.708.46c.35.603.142 1.369-.46 1.709l-1.96 1.128a1.3 1.3 0 0 1-.624.164M140.851 131.941c-.427 0-.854-.23-1.084-.624a1.25 1.25 0 0 1 .46-1.709l1.084-.624a1.24 1.24 0 0 1 1.708.46 1.25 1.25 0 0 1-.46 1.708l-1.084.625a1.3 1.3 0 0 1-.624.164"
      />
      <path
        stroke="#FF0019"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m180.76 125.122-7.033 4.043c-3.171-1.846-8.302-1.869-11.462-.056s-3.16 4.79 0 6.636l-7.033 4.044-52.858-30.852 7.034-4.043c3.171 1.846 8.301 1.869 11.461.057s3.16-4.791 0-6.637l7.034-4.044 52.857 30.863z"
      />
      <path
        fill="#fff"
        d="m275.862 133.999 7.033 4.043c-3.171 1.847-3.171 4.825 0 6.637 3.16 1.813 8.29 1.79 11.462-.056l7.033 4.043-15.381 9.242-25.517-14.667 15.381-9.242z"
      />
      <path
        fill="#FBDED7"
        d="m261.579 142.369 25.517 14.667-38.575 22.482-7.034-4.043c3.172-1.847 3.172-4.825 0-6.637-3.16-1.824-8.29-1.79-11.461.056l-7.034-4.043 38.576-22.482z"
      />
      <path
        fill="#FF0019"
        d="M263.078 144.461c.425 0 .851-.229 1.08-.622a1.237 1.237 0 0 0-.458-1.703l-1.081-.622a1.237 1.237 0 0 0-1.703.458c-.338.6-.142 1.365.459 1.703l1.08.622c.197.109.415.164.623.164M280.085 154.427l-1.954-1.124a1.237 1.237 0 0 1-.459-1.703 1.237 1.237 0 0 1 1.703-.458l1.954 1.124c.601.338.808 1.102.459 1.703-.23.404-.644.622-1.081.622q-.327 0-.622-.164m-5.884-3.373-1.954-1.124a1.237 1.237 0 0 1-.458-1.703 1.24 1.24 0 0 1 1.702-.459l1.954 1.125c.601.338.808 1.102.459 1.703a1.23 1.23 0 0 1-1.081.622q-.327 0-.622-.164m-5.873-3.384-1.954-1.124a1.237 1.237 0 0 1-.458-1.703 1.24 1.24 0 0 1 1.703-.458l1.954 1.124c.6.338.807 1.102.458 1.703a1.23 1.23 0 0 1-1.081.622q-.327 0-.622-.164M285.707 157.473c.425 0 .851-.229 1.08-.622a1.246 1.246 0 0 0-.458-1.703l-1.081-.623a1.24 1.24 0 0 0-1.703.459c-.338.6-.142 1.364.459 1.703l1.08.622c.197.109.415.164.623.164"
      />
      <path
        stroke="#FF0019"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m223.004 164.851 7.033 4.043c3.171-1.846 8.302-1.868 11.462-.056s3.16 4.791 0 6.637l7.033 4.043 52.858-30.863-7.034-4.043c-3.171 1.846-8.301 1.869-11.461.057s-3.16-4.791 0-6.637l-7.034-4.044z"
      />
      <path
        fill="#fff"
        d="m275.862 126.943 7.033 4.044c-3.171 1.846-3.171 4.824 0 6.636 3.16 1.813 8.29 1.79 11.462-.056l7.033 4.043-15.381 9.242-25.517-14.667 15.381-9.242z"
      />
      <path
        fill="#FBDED7"
        d="m261.579 135.324 25.517 14.667-38.575 22.482-7.034-4.043c3.172-1.847 3.172-4.825 0-6.637-3.16-1.824-8.29-1.79-11.461.056l-7.034-4.043 38.576-22.482z"
      />
      <path
        fill="#FF0019"
        d="M263.096 137.441c.43 0 .859-.231 1.09-.627a1.247 1.247 0 0 0-.462-1.717l-1.09-.627a1.247 1.247 0 0 0-1.716.462 1.257 1.257 0 0 0 .462 1.717l1.089.627c.198.11.418.165.627.165M280.24 147.488l-1.969-1.134a1.245 1.245 0 0 1-.462-1.716 1.246 1.246 0 0 1 1.716-.463l1.97 1.134c.605.341.814 1.111.462 1.716a1.24 1.24 0 0 1-1.089.628q-.33 0-.628-.165m-5.931-3.412-1.969-1.133a1.247 1.247 0 0 1-.463-1.717 1.253 1.253 0 0 1 1.717-.462l1.97 1.134c.605.341.814 1.111.462 1.716a1.24 1.24 0 0 1-1.09.627q-.33 0-.627-.165m-5.92-3.4-1.97-1.133a1.25 1.25 0 0 1-.462-1.717 1.25 1.25 0 0 1 1.717-.462l1.97 1.133c.605.341.814 1.112.462 1.717a1.24 1.24 0 0 1-1.09.627q-.33 0-.627-.165M285.908 150.547c.429 0 .858-.231 1.089-.627a1.257 1.257 0 0 0-.462-1.717l-1.09-.627a1.247 1.247 0 0 0-1.716.462 1.256 1.256 0 0 0 .462 1.716l1.089.628c.198.11.418.165.628.165"
      />
      <path
        stroke="#FF0019"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m223.004 157.806 7.033 4.043c3.171-1.846 8.302-1.868 11.462-.056s3.16 4.791 0 6.637l7.033 4.043 52.858-30.863-7.034-4.043c-3.171 1.846-8.301 1.869-11.461.056s-3.16-4.79 0-6.636l-7.034-4.044z"
      />
      <path
        fill="#fff"
        d="m275.862 119.898 7.033 4.043c-3.171 1.846-3.171 4.825 0 6.637 3.16 1.812 8.29 1.79 11.462-.056l7.033 4.043-15.381 9.242-25.517-14.667 15.381-9.242z"
      />
      <path
        fill="#FBDED7"
        d="m261.579 128.268 25.517 14.667-38.575 22.482-7.034-4.043c3.172-1.847 3.172-4.825 0-6.637-3.16-1.824-8.29-1.79-11.461.056l-7.034-4.043 38.576-22.482z"
      />
      <path
        fill="#FF0019"
        d="M263.078 130.36c.425 0 .851-.229 1.08-.622a1.237 1.237 0 0 0-.458-1.703l-1.081-.622a1.237 1.237 0 0 0-1.703.458c-.338.601-.142 1.365.459 1.703l1.08.622c.197.109.415.164.623.164M280.085 140.326l-1.954-1.124a1.237 1.237 0 0 1-.459-1.703 1.237 1.237 0 0 1 1.703-.459l1.954 1.125c.6.338.808 1.102.459 1.703a1.23 1.23 0 0 1-1.081.622q-.327 0-.622-.164m-5.884-3.373-1.954-1.124a1.237 1.237 0 0 1-.458-1.703 1.24 1.24 0 0 1 1.702-.459l1.954 1.125c.601.338.808 1.102.459 1.703a1.23 1.23 0 0 1-1.081.622q-.327 0-.622-.164m-5.873-3.384-1.954-1.124a1.237 1.237 0 0 1-.458-1.703 1.24 1.24 0 0 1 1.703-.459l1.954 1.125c.6.338.807 1.102.458 1.703a1.23 1.23 0 0 1-1.081.622q-.327 0-.622-.164M285.707 143.372c.425 0 .851-.229 1.08-.622a1.246 1.246 0 0 0-.458-1.703l-1.081-.623a1.24 1.24 0 0 0-1.703.459c-.338.6-.142 1.364.459 1.703l1.08.622c.197.109.415.164.623.164"
      />
      <path
        stroke="#FF0019"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m223.004 150.75 7.033 4.043c3.171-1.846 8.302-1.868 11.462-.056s3.16 4.791 0 6.637l7.033 4.043 52.858-30.863-7.034-4.043c-3.171 1.846-8.302 1.869-11.462.056-3.159-1.812-3.159-4.79 0-6.636l-7.033-4.044z"
      />
      <path
        fill="#fff"
        d="m275.862 112.842 7.033 4.043c-3.171 1.846-3.171 4.825 0 6.637 3.16 1.812 8.29 1.79 11.462-.056l7.033 4.043-15.381 9.242-25.517-14.667 15.381-9.242z"
      />
      <path
        fill="#FBDED7"
        d="m261.579 121.224 25.517 14.666-38.575 22.482-7.034-4.043c3.172-1.846 3.172-4.825 0-6.637-3.16-1.824-8.29-1.79-11.461.057l-7.034-4.044 38.576-22.481z"
      />
      <path
        fill="#FF0019"
        d="M263.101 123.346c.429 0 .859-.232 1.091-.628a1.25 1.25 0 0 0-.463-1.72l-1.091-.628a1.25 1.25 0 0 0-1.72.463 1.26 1.26 0 0 0 .463 1.719l1.091.629c.199.11.419.165.629.165M280.275 133.41l-1.973-1.135a1.25 1.25 0 0 1-.463-1.72 1.25 1.25 0 0 1 1.719-.463l1.973 1.135c.607.342.816 1.114.463 1.72-.231.408-.65.628-1.091.628q-.33 0-.628-.165m-5.942-3.417-1.973-1.136a1.25 1.25 0 0 1-.463-1.719 1.254 1.254 0 0 1 1.72-.463l1.973 1.135a1.25 1.25 0 0 1 .463 1.72 1.24 1.24 0 0 1-1.091.628 1.3 1.3 0 0 1-.629-.165m-5.93-3.406-1.974-1.136a1.25 1.25 0 0 1-.462-1.719 1.25 1.25 0 0 1 1.719-.463l1.973 1.135c.607.342.816 1.113.463 1.72a1.24 1.24 0 0 1-1.091.628q-.33 0-.628-.165M285.952 136.475a1.257 1.257 0 0 0 .628-2.348l-1.091-.629a1.25 1.25 0 0 0-1.72.463 1.26 1.26 0 0 0 .463 1.72l1.092.628c.198.11.419.166.628.166"
      />
      <path
        stroke="#FF0019"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m223.004 143.705 7.033 4.043c3.171-1.846 8.302-1.869 11.462-.056s3.16 4.79 0 6.636l7.033 4.044 52.858-30.863-7.034-4.043c-3.171 1.846-8.301 1.868-11.461.056s-3.16-4.791 0-6.637l-7.034-4.043z"
      />
      <path
        fill="#FBDED7"
        d="m141.807 55.153-5.992 5.47c3.489 1.121 4.134 4.02 1.439 6.478s-7.713 3.545-11.201 2.424l-5.992 5.47 41.725 13.399 21.756-19.832-41.724-13.398z"
      />
      <path
        fill="#fff"
        d="m183.531 68.552-21.757 19.831 16.547 5.312 5.992-5.47c-3.489-1.122-4.134-4.021-1.439-6.479s7.713-3.545 11.202-2.424l5.991-5.47-16.547-5.312z"
      />
      <path
        fill="#FF0019"
        d="M182.648 70.873a1.303 1.303 0 0 1-1.156-2.231l.963-.872a1.304 1.304 0 0 1 1.835.08c.487.52.442 1.347-.079 1.834l-.963.872c-.17.159-.385.26-.6.306zM167.052 85.087a1.303 1.303 0 0 1-1.155-2.231l1.733-1.575a1.3 1.3 0 0 1 1.834.08 1.303 1.303 0 0 1-.079 1.834l-1.733 1.575c-.17.158-.385.26-.6.305zm5.199-4.734a1.303 1.303 0 0 1-1.156-2.231l1.733-1.575a1.315 1.315 0 0 1 1.835.08 1.303 1.303 0 0 1-.079 1.834l-1.733 1.574c-.17.159-.385.26-.6.306zm5.198-4.735a1.303 1.303 0 0 1-1.155-2.231l1.733-1.574a1.304 1.304 0 0 1 1.835.08 1.303 1.303 0 0 1-.08 1.834l-1.733 1.574c-.169.159-.385.26-.6.306zM162.635 89.119a1.303 1.303 0 0 1-1.155-2.231l.951-.872a1.304 1.304 0 0 1 1.835.079 1.303 1.303 0 0 1-.079 1.835l-.952.872c-.17.158-.385.26-.6.305z"
      />
      <path
        stroke="#FF0019"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m200.078 73.863-5.991 5.47c-3.489-1.12-8.506-.033-11.201 2.424-2.696 2.458-2.05 5.358 1.438 6.479l-5.991 5.47-58.272-18.722 5.992-5.47c3.488 1.121 8.505.034 11.201-2.423 2.695-2.458 2.05-5.358-1.439-6.479l5.992-5.47z"
      />
      <path
        fill="#ABDCE9"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="M209.547 90.297 136.699 47.96l1.314-3.647 72.848 42.336z"
      />
      <path
        fill="#EDA94F"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="M233.207 58.233c3.986-2.299 8.018-3.545 11.79-3.432 12.368.363 17.147 15.211 10.669 33.174l-1.314 3.647-44.805-1.314 1.314-3.647c4.508-12.481 13.262-23.184 22.346-28.416z"
      />
      <path
        fill="#EDD14F"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="M245.88 54.847c.113 0 .227.023.34.034h.068c.136.011.272.034.396.056.045 0 .079.012.113.023.091.011.182.034.272.045.046 0 .091.023.136.023.079.011.17.034.249.045.046 0 .102.023.148.034.079.012.147.034.226.057.057.011.102.023.159.034.068.023.147.034.215.056a1 1 0 0 1 .158.046c.068.023.148.045.216.068.045.011.101.034.147.045.079.023.147.045.215.068.045.011.091.034.136.045.079.023.158.057.238.091.034.011.079.023.113.045l.34.136s.022 0 .034.011l.306.136c.034.023.079.034.113.057a4 4 0 0 1 .215.102c.045.023.091.045.125.068l.203.102.136.068c.08.045.17.09.25.136l-72.814-42.325s-.091-.045-.136-.08c-.034-.022-.079-.044-.113-.067l-.136-.068-.204-.102c-.045-.023-.091-.045-.125-.068-.068-.034-.147-.068-.215-.102-.034-.023-.079-.034-.113-.056l-.306-.136s-.023 0-.034-.012l-.34-.136c-.034-.01-.079-.022-.113-.045-.079-.034-.158-.056-.238-.09-.045-.012-.09-.035-.136-.046-.068-.022-.147-.045-.215-.068-.045-.011-.102-.034-.147-.045s-.079-.023-.125-.034c-.034 0-.056-.011-.09-.023-.057-.011-.102-.034-.159-.045-.068-.023-.147-.034-.215-.057-.057-.011-.102-.022-.159-.034-.079-.022-.147-.034-.226-.056-.045 0-.102-.023-.147-.034-.08-.012-.159-.034-.25-.046-.045 0-.09-.022-.135-.022h-.034c-.08-.011-.159-.023-.25-.034-.045 0-.079-.011-.124-.023-.136-.023-.261-.034-.397-.056h-.067l-.34-.034h-.148c-.079 0-.147-.012-.226-.023h-.034c-.159 0-.317-.023-.476-.023h-1.268c-.102 0-.204 0-.306.023h-.136c-.124 0-.249.023-.374.034h-.056c-.148.011-.283.034-.431.045-.045 0-.079 0-.124.011-.102.012-.215.034-.317.046h-.136c-.159.022-.329.056-.487.08h-.057c-.147.022-.294.056-.453.09a.4.4 0 0 0-.113.022c-.159.034-.329.068-.487.114-.023 0-.046 0-.068.011-.147.034-.295.08-.442.113-.023 0-.045 0-.068.023a.2.2 0 0 0-.068.023c-.056.01-.124.034-.181.045-.068.023-.125.034-.193.057-.056.022-.124.033-.181.056-.068.023-.124.034-.192.057-.057.022-.125.034-.181.056-.068.023-.125.046-.193.057a1 1 0 0 1-.181.057c-.068.022-.125.045-.193.068-.056.022-.124.045-.181.067-.068.023-.125.046-.193.068-.056.023-.124.046-.181.068-.068.023-.124.046-.192.068-.057.023-.125.046-.181.068a1.4 1.4 0 0 0-.193.08c-.057.022-.125.045-.181.068a1 1 0 0 0-.091.034c-.023 0-.056.022-.079.034-.091.034-.181.079-.272.113-.045.022-.102.045-.147.068l-.306.136c-.034.011-.079.034-.113.045-.136.068-.272.124-.408.192-.023.012-.057.023-.079.046-.114.056-.215.102-.329.158-.045.023-.09.046-.147.068l-.272.136c-.056.023-.102.057-.158.08-.091.045-.182.09-.261.135-.056.023-.102.057-.158.08a4 4 0 0 0-.284.158l-.135.068-.408.238c-.17.09-.329.193-.498.294-.046.034-.102.057-.148.091-.113.068-.238.147-.351.215-.056.034-.113.068-.158.102l-.374.238c-.045.023-.079.057-.125.08-.158.101-.328.215-.487.328-.034.023-.068.045-.113.08-.125.09-.26.18-.385.26-.057.034-.102.079-.159.113-.113.08-.226.158-.351.249-.056.034-.102.08-.158.113-.148.113-.295.215-.442.329-.011 0-.034.022-.045.034-.159.124-.329.249-.487.373-.046.034-.091.08-.148.114a9 9 0 0 1-.351.272c-.056.045-.102.09-.158.124-.125.09-.238.193-.351.295a1 1 0 0 0-.125.101c-.158.136-.317.261-.476.397-.034.023-.056.057-.09.08-.125.113-.261.226-.385.339-.057.045-.102.09-.159.136-.113.102-.226.192-.328.294-.046.046-.102.091-.148.136-.135.125-.271.25-.396.374l-.068.068c-.158.147-.317.294-.464.442-.046.045-.091.079-.136.124-.113.113-.227.215-.34.329-.023.022-.057.045-.079.079l-.057.057c-.204.203-.408.407-.611.622a1 1 0 0 0-.091.102c-.215.216-.419.442-.634.657-.012.012-.023.034-.046.046-.203.226-.419.453-.622.68-.023.022-.034.044-.057.056-.204.226-.408.453-.612.69-.022.023-.034.046-.056.069-.012.022-.034.034-.046.056-.158.182-.305.363-.464.544-.011.023-.034.034-.045.057-.136.17-.272.328-.419.498-.046.056-.091.113-.136.159-.125.147-.238.294-.363.441-.034.046-.068.08-.102.125-.147.192-.294.373-.441.566 0 .011-.023.023-.023.034-.034.045-.068.08-.091.125-.09.113-.181.237-.271.35-.046.069-.102.125-.148.193-.079.113-.17.227-.249.34-.045.068-.102.136-.147.193-.091.124-.17.237-.261.362-.045.057-.09.113-.124.181-.113.159-.227.317-.34.487-.011.012-.023.034-.034.046-.124.17-.238.34-.351.51-.034.044-.068.101-.102.146-.079.125-.17.25-.249.374l-.136.204c-.068.113-.147.215-.215.328-.045.068-.091.148-.147.216l-.204.306c-.012.022-.034.045-.046.079-.011.022-.022.045-.045.068-.192.306-.385.623-.578.928-.022.034-.045.08-.067.114-.193.306-.374.623-.567.94 0 .022-.022.034-.034.056-.011.023-.022.046-.045.068-.181.306-.351.612-.521.918-.023.045-.045.09-.068.124-.17.306-.34.623-.51.94 0 .023-.022.034-.022.057a.5.5 0 0 0-.034.08c-.17.305-.329.622-.487.94a.5.5 0 0 0-.057.112c-.158.318-.317.635-.476.963 0 .011-.011.023-.022.034-.034.08-.08.159-.113.238-.046.09-.08.17-.125.26a7 7 0 0 1-.136.295c-.034.08-.079.17-.113.25l-.136.305c-.034.08-.079.17-.113.25a7 7 0 0 0-.136.316c-.034.08-.068.159-.114.25 0 0 0 .022-.011.022-.034.09-.079.17-.113.26-.045.091-.079.193-.125.284-.045.09-.079.192-.124.283-.034.09-.08.192-.114.283a3 3 0 0 0-.113.294c-.034.091-.079.193-.113.284-.034.102-.079.192-.113.294-.034.09-.08.193-.114.283v.023c-.045.113-.09.238-.136.351a1 1 0 0 1-.079.193c-.068.192-.136.385-.215.577l72.848 42.336c.068-.192.136-.385.215-.578.022-.068.045-.124.079-.192.045-.125.091-.25.147-.374.034-.09.068-.192.114-.283.034-.102.079-.193.113-.294.034-.091.079-.193.113-.284.034-.102.079-.192.113-.294.034-.09.08-.181.114-.272.045-.102.079-.192.124-.294.034-.091.079-.182.113-.272.046-.102.08-.193.125-.295l.102-.237c.045-.102.091-.216.136-.318.034-.079.079-.17.113-.249l.136-.306c.034-.079.079-.17.113-.249.046-.102.091-.204.136-.294s.079-.17.125-.26c.045-.091.09-.182.124-.273.159-.317.318-.645.476-.962a.5.5 0 0 0 .057-.114c.158-.317.317-.622.487-.94.022-.045.045-.079.068-.124.17-.317.339-.623.509-.94q.035-.07.068-.125c.17-.306.351-.611.521-.917.023-.046.046-.09.08-.125.181-.317.373-.634.566-.94.022-.045.045-.08.068-.124.192-.317.385-.623.577-.93.034-.044.057-.09.091-.135l.204-.306c.045-.068.09-.147.147-.215.068-.113.147-.215.215-.328l.136-.204c.079-.125.17-.25.249-.374.034-.045.068-.102.102-.147.114-.17.238-.34.351-.51.012-.023.023-.034.034-.057.114-.158.227-.328.34-.487.045-.056.091-.113.125-.18l.26-.363c.046-.068.102-.136.147-.193.08-.113.17-.226.25-.34.045-.067.102-.124.147-.192.09-.113.181-.238.272-.351.045-.057.079-.113.124-.159.147-.192.295-.374.442-.566.034-.045.068-.08.102-.125.124-.147.238-.294.362-.441.046-.057.091-.102.136-.159.136-.17.272-.328.419-.498.012-.023.034-.034.046-.057.158-.181.305-.362.464-.543.034-.046.068-.08.102-.125.204-.227.408-.464.611-.69.023-.024.034-.046.057-.058.204-.226.408-.453.623-.68.011-.01.023-.033.045-.044.204-.227.419-.442.635-.657a.7.7 0 0 0 .09-.102c.204-.204.408-.42.612-.623l.136-.136c.113-.113.226-.215.339-.329.046-.045.091-.09.136-.124.159-.147.306-.295.465-.442l.068-.068c.136-.124.26-.249.396-.362.045-.046.102-.09.147-.136l.329-.295c.056-.045.102-.09.158-.136.125-.113.261-.226.385-.34.034-.022.057-.056.091-.079.159-.136.317-.271.476-.396.045-.034.09-.068.124-.102.114-.102.238-.192.351-.294.057-.046.102-.091.159-.125.113-.09.226-.181.351-.272.045-.034.091-.079.147-.113.159-.125.317-.25.487-.374.012 0 .034-.022.046-.034.147-.113.294-.215.441-.328.057-.034.102-.08.159-.114.113-.079.226-.17.351-.249.057-.034.102-.079.159-.113.124-.09.26-.181.385-.26.034-.023.068-.046.113-.08.158-.113.328-.215.487-.328.045-.023.079-.057.124-.08l.374-.237.17-.102c.113-.068.238-.147.351-.215.045-.034.102-.057.147-.091.17-.102.329-.193.499-.294l.407-.238.136-.068c.091-.057.193-.102.284-.159.056-.022.101-.056.158-.08.091-.044.181-.09.261-.135.056-.023.102-.057.158-.08l.272-.135c.045-.023.102-.046.147-.068.113-.057.215-.113.329-.159.022-.011.056-.022.079-.045.136-.068.272-.125.408-.192.034-.023.079-.034.113-.046l.306-.136c.045-.022.102-.045.147-.068.091-.034.181-.079.26-.113l.17-.068c.057-.023.125-.045.182-.068.068-.023.124-.045.192-.08.057-.022.125-.044.181-.067l.193-.068c.056-.023.124-.045.181-.068l.193-.068c.056-.023.124-.045.181-.068.068-.023.124-.045.192-.068.057-.023.125-.045.182-.056.068-.023.124-.046.192-.057.057-.023.125-.034.181-.057.068-.022.125-.034.193-.056.056-.023.124-.034.181-.057.068-.023.125-.034.193-.057.056-.011.113-.034.181-.045l.136-.034c.147-.034.294-.08.441-.113.023 0 .046 0 .068-.012.159-.034.329-.079.487-.113.046 0 .08-.011.125-.022.147-.034.294-.057.453-.091h.057c.158-.034.328-.057.487-.08q.067-.002.136-.022c.101-.011.215-.034.317-.045.045 0 .079 0 .124-.012.148-.022.283-.034.431-.045h.056l.374-.034h.136c.102 0 .204-.011.306-.022h1.268q.238.002.476.022c.091 0 .17.012.26.023h.148z"
      />
      <path
        fill="#70C0DB"
        stroke="#FF0019"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.655}
        d="m255.666 87.964-1.314 3.647-44.805-1.314 1.314-3.647z"
      />
      <g clipPath="url(#img-guide01_svg__d)">
        <path
          fill="#FF0019"
          stroke="#FF0019"
          strokeMiterlimit={10}
          strokeWidth={0.828}
          d="M193.423 220.074c1.829 1.051 1.837 2.765.024 3.824-1.812 1.052-4.767 1.052-6.597 0l-4.494-2.59c-1.83-1.052-1.838-2.765-.025-3.825 1.812-1.051 4.768-1.051 6.597 0zM184.407 225.008c1.829 1.051 1.837 2.765.025 3.824-1.813 1.051-4.768 1.051-6.598 0l-4.494-2.591c-1.83-1.051-1.838-2.765-.025-3.824 1.813-1.051 4.768-1.051 6.597 0z"
        />
        <path
          fill="#FADDD6"
          stroke="#FF0019"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.655}
          d="M172.497 190.441c-.687 12.06 1.043 32.481 1.043 32.481 1.019 1.2 3.295 1.68 5.083.281l1.233-27.018h1.987l.596 22.292c1.581 1.316 3.286 1.316 4.801-.017 0 0 .48-11.82 1.614-26.066l-5.281-4.387c-7.053 2.334-4.098 4.967-11.084 2.434z"
        />
        <path
          fill="#FF0019"
          stroke="#FF0019"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.655}
          d="m189.152 188.388 2.524-2.417.555 12.3c-1.805 3.882-5.72 5.422-10.049 7.202-8.534 3.509-11.82-.572-11.82-.572l.496-17.3s11.092 3.154 18.294.779z"
        />
        <path
          fill="#F9EAAC"
          stroke="#FF0019"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.655}
          d="m198.272 172.262-5.297-2.434-6.945 7.856c-1.027 4.826 6.407 6.945 8.269 3.154 1.465-2.583 3.973-8.576 3.973-8.576"
        />
        <path
          fill="#F9EAAC"
          stroke="#FF0019"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.655}
          d="M170.351 191.45c2.575 4.983 18.269 2.491 22.201-5.38l-.712-7.111s1.846-5.711.132-11.895c-.538-1.928-2.839-3.12-4.138-4.304-1.292-1.175-5.538-2.409-5.538-2.409l-9.047 2.409c-3.03 1.896-5.969 6.117-5.43 9.652.306 2.044 2.764 10.694 2.764 10.694z"
        />
        <path
          fill="#FBDED7"
          stroke="#FF0019"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.655}
          d="M192.379 171.724a3.547 3.547 0 0 1-3.543 3.543 3.546 3.546 0 0 1-3.542-3.543 3.547 3.547 0 0 1 3.542-3.543 3.547 3.547 0 0 1 3.543 3.543"
        />
        <path
          fill="#F9EAAC"
          d="M175.559 177.528c2.806-.687 9.188-5.215 9.188-5.215 1.912.687 2.798 1.49 3.427 3.766-1.813 2.185-3.783 4.371-5.563 6.034-2.839 2.376-6.175 4.305-9.544 2.26-1.374-.836-3.369-4.056-3.675-5.629"
        />
        <path
          stroke="#FF0019"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.655}
          d="M175.559 177.528c2.806-.687 9.188-5.215 9.188-5.215 1.912.687 2.798 1.49 3.427 3.766-1.813 2.185-3.783 4.371-5.563 6.034-2.839 2.376-6.175 4.305-9.544 2.26-1.374-.836-3.369-4.056-3.675-5.629"
        />
        <path
          stroke="#FF0019"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.655}
          d="M175.559 177.528c2.806-.687 9.188-5.215 9.188-5.215 1.912.687 2.798 1.49 3.427 3.766-1.813 2.185-3.783 4.371-5.563 6.034-2.839 2.376-6.175 4.305-9.544 2.26-1.374-.836-3.369-4.056-3.675-5.629"
        />
        <path
          fill="#FF0019"
          stroke="#FF0019"
          strokeMiterlimit={10}
          strokeWidth={1.655}
          d="M190.119 163.647a.6.6 0 0 0-.257.464l.033 13.103c0 .174.116.24.257.157l5.355-3.261a.6.6 0 0 0 .257-.464l-.033-13.103c0-.174-.116-.24-.257-.157z"
        />
        <path
          fill="#FBDED7"
          stroke="#FF0019"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.655}
          d="M200.368 169.258a3.547 3.547 0 0 1-3.543 3.543 3.546 3.546 0 0 1-3.542-3.543 3.546 3.546 0 0 1 3.542-3.542 3.546 3.546 0 0 1 3.543 3.542"
        />
        <path
          fill="#FF0019"
          d="m185.211 161.767.654 6.382a.377.377 0 0 0 .629.24l2.392-2.152a.36.36 0 0 0 .124-.248c.075-1.018.423-7.16-.72-13.211-.836-4.453-7.267-4.321-7.267-4.321l4.18 13.31z"
        />
        <path
          fill="#FADDD6"
          stroke="#FF0019"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.655}
          d="M178.845 164.4a8.997 8.997 0 0 1-8.997-8.997 8.997 8.997 0 0 1 8.997-8.998 8.997 8.997 0 0 1 8.998 8.998 8.997 8.997 0 0 1-8.998 8.997"
        />
        <path
          fill="#FF0019"
          d="M177.902 157.116a1.4 1.4 0 1 1 .002-2.8 1.4 1.4 0 0 1-.002 2.8M183.406 156.015a1.4 1.4 0 1 1 0-2.798 1.4 1.4 0 0 1 0 2.798"
        />
        <path
          fill="#FF0019"
          d="M173.29 155.717s7.731-2.873 9.163-8.294c0 0-.704-1.788-5.132-1.25-6.606.803-8.294 6.572-8.783 9.544-.728 4.445 1.689 12.896 2.078 14.204a.36.36 0 0 0 .223.24l3.957 1.539a.378.378 0 0 0 .513-.397z"
        />
        <path fill="#FF0019" d="M181.261 149.178s2.558 4.329 6.093 5.14l-.894-4.254-4.454-3.659z" />
      </g>
    </g>
    <defs>
      <linearGradient
        id="img-guide01_svg__b"
        x1={99.139}
        x2={85.648}
        y1={208.127}
        y2={246.209}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A" />
        <stop offset={0.29} stopColor="#F5B3A4" />
        <stop offset={0.75} stopColor="#F9D2C8" />
        <stop offset={1} stopColor="#FBDED7" />
      </linearGradient>
      <linearGradient
        id="img-guide01_svg__c"
        x1={268.368}
        x2={267.046}
        y1={256.121}
        y2={202.98}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A" />
        <stop offset={0.43} stopColor="#EF9282" />
        <stop offset={1} stopColor="#EB7D74" />
      </linearGradient>
      <clipPath id="img-guide01_svg__a">
        <path fill="#fff" d="M8 8h347v272H8z" />
      </clipPath>
      <clipPath id="img-guide01_svg__d">
        <path fill="#fff" d="M201.195 145.575h-34.269v84.456h34.269z" />
      </clipPath>
    </defs>
  </svg>
);
